import {Component, OnInit} from '@angular/core';
import {BaseComponent} from '../BaseComponent';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginService} from '../../services/login.service';
import {HttpClient} from '@angular/common/http';
import {UserService} from '../../services/api/UserService';
import {LoaderService} from '../general-services/service-loader/loader.service';
import {FormBuilder} from '@angular/forms';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent extends BaseComponent implements OnInit {

  constructor(private http: HttpClient, router: Router, route: ActivatedRoute,
              private loginService: LoginService, private userService: UserService,
              private loaderService: LoaderService, private formBuilder: FormBuilder) {
    super(route, router);
  }

  ngOnInit() {
  }

}
